import { render, staticRenderFns } from "./LoginSignupPage.vue?vue&type=template&id=76380803&"
import script from "./LoginSignupPage.vue?vue&type=script&lang=js&"
export * from "./LoginSignupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports